import { Box, Typography } from "@material-ui/core";
import { AuthForm } from "pages/VisitPage/Forms/AuthForm";
import { LogoPngVerTwo } from "icon/LogoPng";
import { useAuthPageStyles } from "./styles";
import useResize from "hooks/useResize";

const AuthPage = () => {
  const classes = useAuthPageStyles();
  const { width } = useResize();

  return (
    <Box className={classes.root}>
      <Box className={classes.authBox}>
        <AuthForm />
      </Box>
      <Box className={classes.box}>
        <Box className={classes.textContent}>
          <LogoPngVerTwo width={width > 1280 ? 300 : 200} height={width > 1280 ? 120 : 80} />
          <Typography className={classes.title}>
            Quality delivery is our goal. Let's have a productive day and stay safe.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthPage;
